module.exports = __webpack_public_path__ + "img/iss_space.5256ddbb.jpg";